const countries_list = {"zh-cn": "cn", "zh-hk": "hk", "zh-tw": "tw"};
const meta_field_sim = ["内容","发送","生产区","评论"];
const meta_field_tra = ["內容","發送","生產區","評論"];

const slideshow1 = "#shopify-section-template--14379916034328__166330798921244c6e";
const slideshow2 = "#shopify-section-template--14379916034328__48ffe7e3-5ad5-48a0-9445-638a8b288aa5";
const slideshow3 = "#shopify-section-template--14379916034328__08dabeec-73d1-4426-970b-a45ba51464b4";

const topBanner1 = "#shopify-section-template--14379916034328__1664453243de9bb844";
const topBanner2 = "#shopify-section-template--14379916034328__d9d12211-80be-4cb9-836d-6a4f990b882a";
const topBanner3 = "#shopify-section-template--14379916034328__718de1a5-de2c-46f6-9113-b29d93e5f01a";

const productDetailBanner1 = "#shopify-section-template--14379916198168__166435985653518cea";
const productDetailBanner2 = "#shopify-section-template--14379916198168__6ce36294-fa1e-40d7-94e3-f568e927e53d";
const productDetailBanner3 = "#shopify-section-template--14379916198168__39817e7c-f07b-4542-9fac-d0d9b3996c09";

const topObsession1 = "#topObsession-ja";
const topObsession2 = "#topObsession-cn";
const topObsession3 = "#topObsession-zh";


function getCountryByUrl() {  
  const country = location.pathname.split('/');
  if (countries_list[(country[1])]) {
    return (countries_list[(country[1])]);
  } else {
    return "ja";
  }
}

$(function() {
  if (getCountryByUrl() === "ja") { //日本

    //メインビジュアル
    $(slideshow1).show();
    $(slideshow2).hide();
    $(slideshow3).hide();

    //トップページ下層バナー
    $(topBanner1).show();
    $(topBanner2).hide();
    $(topBanner3).hide();

    //商品詳細バナー
    $(productDetailBanner1).show();
    $(productDetailBanner2).hide();
    $(productDetailBanner3).hide();

    //こだわり
    $(topObsession1).show();
    $(topObsession2).hide();
    $(topObsession3).hide();
    
  } else if(getCountryByUrl() === "cn") { //簡体字

    //メインビジュアル
    $(slideshow1).hide();
    $(slideshow2).show();
    $(slideshow3).hide();

    //トップページ下層バナー
    $(topBanner1).hide();
    $(topBanner2).show();
    $(topBanner3).hide();

    //商品詳細バナー
    $(productDetailBanner1).hide();
    $(productDetailBanner2).show();
    $(productDetailBanner3).hide();
    
    //商品詳細
    $("#meta_field1").text(meta_field_sim[0]);
    $("#meta_field2").text(meta_field_sim[1]);
    $("#meta_field3").text(meta_field_sim[2]);
    $("#meta_field4").text(meta_field_sim[3]);

     //こだわり
    $(topObsession1).hide();
    $(topObsession2).show();
    $(topObsession3).hide();
    
  } else { //繁体字

    //メインビジュアル
    $(slideshow1).hide();
    $(slideshow2).hide();
    $(slideshow3).show();

    //トップページ下層バナー
    $(topBanner1).hide();
    $(topBanner2).hide();
    $(topBanner3).show();

    //商品詳細バナー
    $(productDetailBanner1).hide();
    $(productDetailBanner2).hide();
    $(productDetailBanner3).show();
    
    //商品詳細
    $("#meta_field1").text(meta_field_tra[0]);
    $("#meta_field2").text(meta_field_tra[1]);
    $("#meta_field3").text(meta_field_tra[2]);
    $("#meta_field4").text(meta_field_tra[3]);

    //こだわり
    $(topObsession1).hide();
    $(topObsession2).hide();
    $(topObsession3).show();
  }
});

  //レビュー
window.setTimeout(function(){
  if (getCountryByUrl() === "ja") {  //日本語
    $(".spr-summary-actions-newreview").text("レビューを書く"); 
    $(".spr-header-title").text("みんなのレビュー");
    $(".spr-summary-actions-togglereviews").append("件のレビュー");
    $(".spr-review-reportreview").text("不適切として報告");
    $(".spr-review-reportreview").attr("data-msg","このレビューはすでに不適切として報告されています");
  //レビュー投稿
    $(".spr-form-title").text("レビューを書く");
    $(".spr-form-contact-name label").text("ニックネーム");
    $(".spr-form-contact-email label").text("メールアドレス");
    $(".spr-form-review-rating label").text("評価");
    $(".spr-form-review-title label").text("タイトル");
    $(".spr-button-primary").val("投稿する");  
    
  } else if (getCountryByUrl() === "cn") {  //簡体字
    $(".spr-summary-actions-newreview").text("写评论"); //評価を書く
    $(".spr-header-title").text("大家的评价"); //みんなのレビュー
    $(".spr-summary-actions-togglereviews").append("条评论"); //件のレビュー
    $(".spr-review-reportreview").text("举报不当");//不適切として報告
    $(".spr-review-reportreview").attr("data-msg","此评论已被标记为不当");
    
    
    //レビュー投稿
    $(".spr-form-title").text("写评论");
    $(".spr-form-contact-name label").text("昵称");//ニックネーム
    $(".spr-form-contact-email label").text("电子邮件地址");//メアド
    $(".spr-form-review-rating label").text("评估");//評価
    $(".spr-form-review-title label").text("标题");//タイトル
    $(".spr-button-primary").val("邮政");//投稿する

    
  } else { //繁体字
    $(".spr-summary-actions-newreview").text("寫評論"); //評価を書く
    $(".spr-header-title").text("大家的評價"); //みんなのレビュー
    $(".spr-summary-actions-togglereviews").append("條評論"); //件のレビュー
    $(".spr-review-reportreview").text("舉報不當");//不適切として報告
    $(".spr-review-reportreview").attr("data-msg","此評論已被標記為不當");

    //レビュー投稿
    $(".spr-form-title").text("寫評論");
    $(".spr-form-contact-name label").text("暱稱");//ニックネーム
    $(".spr-form-contact-email label").text("電子郵件地址");//メアド
    $(".spr-form-review-rating label").text("評估");//評価
    $(".spr-form-review-title label").text("標題");//タイトル
    $(".spr-button-primary").val("郵政");//投稿する

    
  }
}, 3000);
